import { EnhancedDatasetResult } from 'libs/shared/contract-common/src/lib/data-view';
import { Observable } from 'rxjs';

/**
 * Abstract class to provide the re-ordering functionality provided by the SwitchViewReorderingService
 */
export abstract class SwitchViewReorderingFacade {
  abstract dragOverStream$: Observable<DragEvent>;
  abstract dropIndex$: Observable<number>;
  abstract currentDatasetDragIndex$: Observable<number>;
  abstract sortedEnhancedDatasetResults$: Observable<EnhancedDatasetResult[]>;

  // menu actions
  abstract onMoveDatasetUp(
    reportToken: string,
    enhancedDatasetResults: EnhancedDatasetResult[],
    pos: number
  ): EnhancedDatasetResult[];
  abstract onMoveDatasetDown(
    reportToken: string,
    enhancedDatasetResults: EnhancedDatasetResult[],
    pos: number
  ): EnhancedDatasetResult[];
  abstract onMoveDatasetToTop(
    reportToken: string,
    enhancedDatasetResults: EnhancedDatasetResult[],
    pos: number
  ): EnhancedDatasetResult[];
  abstract onMoveDatasetToBottom(
    reportToken: string,
    enhancedDatasetResults: EnhancedDatasetResult[],
    pos: number
  ): EnhancedDatasetResult[];

  // drag and drop actions
  abstract onDatasetDragStart($event: DragEvent, pos: number): void;
  abstract onDatasetDragEnd($event: DragEvent, pos: number): void;
  abstract onDatasetDragEnter($event: DragEvent): void;
  abstract onDatasetDragOver($event: DragEvent): void;
  abstract onDragOverNonDraggableDropZone($event: DragEvent, enhancedDatasetResults: EnhancedDatasetResult[]): void;
  abstract onDatasetDragLeave($event: DragEvent): void;
  abstract onDatasetDrop(
    reportToken: string,
    $event: DragEvent,
    enhancedDatasetResults: EnhancedDatasetResult[]
  ): EnhancedDatasetResult[];

  abstract calculateDropIndexFromDragEvent($event: DragEvent, dropZone: HTMLElement, indexAttribute: string): void;
  abstract pushToDragOverStream($event: DragEvent): void;
}
